// src/data/hospitals.js
// Hospital and urgent care data for the New Orleans metro area.
// lat/lon used for distance calculation and map display.

export const HOSPITALS = [
  // ── Full-service hospitals with 24/7 ER ──────────────────────────
  {
    id: 'umc',
    name: 'University Medical Center',
    shortName: 'UMC New Orleans',
    type: 'hospital',
    level: 1,
    trauma: true,
    er24: true,
    address: '2000 Canal St, New Orleans, LA 70112',
    phone: '5049031000',
    lat: 29.9543, lon: -90.0823,
    services: ['Trauma Center Level 1', 'Emergency Room', 'ICU', 'Surgery', 'Pediatrics'],
    notes: 'Level 1 Trauma Center. Primary facility for major emergencies.',
  },
  {
    id: 'tulane',
    name: 'Tulane Medical Center',
    shortName: 'Tulane Medical',
    type: 'hospital',
    level: 1,
    trauma: false,
    er24: true,
    address: '1415 Tulane Ave, New Orleans, LA 70112',
    phone: '5049885263',
    lat: 29.9534, lon: -90.0834,
    services: ['Emergency Room', 'Surgery', 'Cardiology', 'Neurology'],
    notes: '24/7 Emergency Room. Academic medical center.',
  },
  {
    id: 'ochsner_main',
    name: 'Ochsner Medical Center',
    shortName: 'Ochsner Main',
    type: 'hospital',
    level: 2,
    trauma: false,
    er24: true,
    address: '1516 Jefferson Hwy, Jefferson, LA 70121',
    phone: '5048425200',
    lat: 29.9432, lon: -90.1467,
    services: ['Emergency Room', 'Heart & Vascular', 'Cancer Center', 'Pediatrics'],
    notes: 'Major regional hospital. Jefferson Parish.',
  },
  {
    id: 'east_jefferson',
    name: 'East Jefferson General Hospital',
    shortName: 'East Jefferson',
    type: 'hospital',
    level: 2,
    trauma: false,
    er24: true,
    address: '4200 Houma Blvd, Metairie, LA 70006',
    phone: '5048491000',
    lat: 29.9912, lon: -90.1754,
    services: ['Emergency Room', 'Surgery', 'Maternity', 'Heart Center'],
    notes: 'Jefferson Parish primary hospital.',
  },
  {
    id: 'lakeview',
    name: 'Lakeview Regional Medical Center',
    shortName: 'Lakeview Regional',
    type: 'hospital',
    level: 2,
    trauma: false,
    er24: true,
    address: '95 Judge Tanner Blvd, Covington, LA 70433',
    phone: '9858671111',
    lat: 30.4738, lon: -90.1173,
    services: ['Emergency Room', 'Surgery', 'Orthopedics'],
    notes: 'Northshore primary hospital. St. Tammany Parish.',
  },
  {
    id: 'slidell_memorial',
    name: 'Slidell Memorial Hospital',
    shortName: 'Slidell Memorial',
    type: 'hospital',
    level: 2,
    trauma: false,
    er24: true,
    address: '1001 Gause Blvd, Slidell, LA 70458',
    phone: '9856496000',
    lat: 30.2782, lon: -89.8192,
    services: ['Emergency Room', 'Surgery', 'Heart Center'],
    notes: 'Eastern Northshore hospital.',
  },
  {
    id: 'childrens',
    name: "Children's Hospital New Orleans",
    shortName: "Children's Hospital",
    type: 'hospital',
    level: 2,
    trauma: false,
    er24: true,
    pediatric: true,
    address: '200 Henry Clay Ave, New Orleans, LA 70118',
    phone: '5048998511',
    lat: 29.9289, lon: -90.1076,
    services: ['Pediatric ER', 'NICU', 'Pediatric Surgery', 'Behavioral Health'],
    notes: 'For children under 21. Dedicated pediatric emergency room.',
  },
  {
    id: 'west_jefferson',
    name: 'West Jefferson Medical Center',
    shortName: 'West Jefferson',
    type: 'hospital',
    level: 2,
    trauma: false,
    er24: true,
    address: '1101 Medical Center Blvd, Marrero, LA 70072',
    phone: '5043473511',
    lat: 29.8673, lon: -90.1062,
    services: ['Emergency Room', 'Heart Center', 'Womens Services'],
    notes: 'West Bank primary hospital.',
  },

  // ── Urgent Care (not 24/7 ER) ─────────────────────────────────────
  {
    id: 'ochsner_urgent_1',
    name: 'Ochsner Urgent Care - Uptown',
    shortName: 'Ochsner Urgent Care',
    type: 'urgent_care',
    er24: false,
    address: '3434 Prytania St, New Orleans, LA 70115',
    phone: '5049106700',
    lat: 29.9276, lon: -90.1054,
    services: ['Urgent Care', 'Walk-in Clinic', 'Lab', 'X-ray'],
    hours: 'Mon-Fri 8am-8pm, Sat-Sun 8am-5pm',
    notes: 'Walk-in care for non-emergency conditions.',
  },
  {
    id: 'medexpress_metairie',
    name: 'MedExpress Urgent Care - Metairie',
    shortName: 'MedExpress Metairie',
    type: 'urgent_care',
    er24: false,
    address: '3800 Veterans Blvd, Metairie, LA 70002',
    phone: '5044556560',
    lat: 29.9954, lon: -90.1716,
    services: ['Urgent Care', 'Occupational Health', 'X-ray'],
    hours: '8am-8pm daily',
    notes: 'Walk-in only.',
  },
  // ── St. John Parish ──────────────────────────────────────────────
  { id: 'ochsner-river-parishes', shortName: 'Ochsner River Parishes', name: 'Ochsner Medical Complex - River Parishes', address: '1900 W Airline Hwy, LaPlace, LA 70068', phone: '9856527000', lat: 30.0749, lon: -90.5036, er24: true, type: 'ER' },
  { id: 'southeast-regional-lp', shortName: 'Southeast Regional', name: 'Southeast Regional Medical Center', address: '501 Rue de Sante, LaPlace, LA 70068', phone: '9856530950', lat: 30.0734, lon: -90.5159, er24: true, type: 'ER' },
  // ── St. James Parish ─────────────────────────────────────────────
  { id: 'st-james-er', shortName: 'St. James Hospital', name: 'St. James Parish Hospital', address: '1645 Lutcher Ave, Lutcher, LA 70071', phone: '2252585949', lat: 30.0520, lon: -90.7039, er24: true, type: 'ER' },
  // ── Tangipahoa Parish ────────────────────────────────────────────
  { id: 'north-oaks-er', shortName: 'North Oaks', name: 'North Oaks Medical Center', address: '15790 Paul Vega MD Dr, Hammond, LA 70403', phone: '9853452700', lat: 30.4659, lon: -90.4614, er24: true, type: 'ER' },
  { id: 'patient-plus-hammond', shortName: 'Patient Plus Hammond', name: 'Patient Plus Urgent Care - Hammond', address: '1706 SW Railroad Ave, Hammond, LA 70403', phone: '9858267782', lat: 30.4863, lon: -90.4574, er24: false, type: 'URGENT CARE' },
  { id: 'maxem-hammond', shortName: 'Maxem Health', name: 'Maxem Health Urgent Care', address: '2741 W Thomas St, Hammond, LA 70401', phone: '9855422299', lat: 30.5020, lon: -90.4921, er24: false, type: 'URGENT CARE' },
  // ── Livingston Parish ────────────────────────────────────────────
  { id: 'olol-livingston', shortName: 'OLOL Livingston', name: 'Our Lady of the Lake - Livingston', address: "O'Donovan Blvd, Denham Springs, LA 70726", phone: '2252716000', lat: 30.4623, lon: -90.8650, er24: true, type: 'ER' },
  { id: 'lake-urgent-denham', shortName: 'Lake Urgent Care', name: 'Lake Urgent Care - Denham Springs', address: '31985 LA-16, Denham Springs, LA 70726', phone: '2257918800', lat: 30.5319, lon: -90.9567, er24: false, type: 'URGENT CARE' },
  { id: 'fast-pace-denham', shortName: 'Fast Pace Health', name: 'Fast Pace Health Urgent Care - Denham Springs', address: '300 Florida Ave SE, Denham Springs, LA 70726', phone: '2255236022', lat: 30.4833, lon: -90.9529, er24: false, type: 'URGENT CARE' },
  // ── Ascension Parish ─────────────────────────────────────────────
  { id: 'olol-st-elizabeth', shortName: 'OLOL St. Elizabeth', name: 'Our Lady of the Lake St. Elizabeth', address: '1125 LA-30 W, Gonzales, LA 70737', phone: '2256475000', lat: 30.2098, lon: -90.9318, er24: true, type: 'ER' },
  { id: 'coastal-urgent-gonzales', shortName: 'Coastal Urgent Care', name: 'Coastal Urgent Care of Gonzales', address: '1124 S Burnside Ave, Gonzales, LA 70737', phone: '2256445503', lat: 30.2239, lon: -90.9203, er24: false, type: 'URGENT CARE' },
  { id: 'lake-urgent-gonzales', shortName: 'Lake Urgent Gonzales', name: 'Lake Urgent Care - Gonzales', address: '1776 N Airline Hwy, Gonzales, LA 70737', phone: '2256474988', lat: 30.2487, lon: -90.9221, er24: false, type: 'URGENT CARE' },
  // ── St. Tammany Parish ───────────────────────────────────────────
  { id: 'covington-trace-er', shortName: 'Covington Trace ER', name: 'Covington Trace ER & Hospital', address: '4107 LA-59, Mandeville, LA 70471', phone: '9859513650', lat: 30.4118, lon: -90.0404, er24: true, type: 'ER' },
  { id: 'lakeview-hospital', shortName: 'Lakeview Hospital', name: 'Lakeview Hospital', address: '95 Judge Tanner Blvd, Covington, LA 70433', phone: '9858673800', lat: 30.4111, lon: -90.0807, er24: true, type: 'ER' },
  { id: 'st-tammany-parish-hosp', shortName: 'St. Tammany Hospital', name: 'St. Tammany Parish Hospital', address: '1202 S Tyler St, Covington, LA 70433', phone: '9858984000', lat: 30.4690, lon: -90.1130, er24: true, type: 'ER' },
  { id: 'sths-mandeville-er', shortName: 'STHS Mandeville', name: 'STHS Mandeville Emergency Department', address: '2929 US-190, Mandeville, LA 70471', phone: '9857731550', lat: 30.3898, lon: -90.0805, er24: true, type: 'ER' },
  // ── Terrebonne Parish ────────────────────────────────────────────
  { id: 'terrebonne-general-er', shortName: 'Terrebonne General', name: 'Terrebonne General Health System', address: '8166 W Main St, Houma, LA 70360', phone: '9858734141', lat: 29.5973, lon: -90.7138, er24: true, type: 'ER' },
  { id: 'chabert-medical-er', shortName: 'Chabert Medical', name: 'Leonard J. Chabert Medical Center', address: '1978 Industrial Blvd, Houma, LA 70363', phone: '9858732200', lat: 29.5698, lon: -90.6887, er24: true, type: 'ER' },
  // ── Lafourche Parish ─────────────────────────────────────────────
  { id: 'thibodaux-regional-er', shortName: 'Thibodaux Regional', name: 'Thibodaux Regional Medical Center', address: '602 N Acadia Rd, Thibodaux, LA 70301', phone: '9854475500', lat: 29.7811, lon: -90.8065, er24: true, type: 'ER' },
  // ── Calcasieu Parish ─────────────────────────────────────────────
  { id: 'christus-lake-area-er', shortName: 'CHRISTUS Lake Area', name: 'CHRISTUS Ochsner Lake Area Hospital', address: '4200 Nelson Rd, Lake Charles, LA 70605', phone: '3374746370', lat: 30.1810, lon: -93.2506, er24: true, type: 'ER' },
  { id: 'christus-st-patrick-er', shortName: 'CHRISTUS St. Patrick', name: 'CHRISTUS Ochsner St. Patrick Hospital', address: '524 Dr Michael Debakey Dr, Lake Charles, LA 70601', phone: '3374362511', lat: 30.2162, lon: -93.2275, er24: true, type: 'ER' },
  { id: 'lake-charles-memorial-er', shortName: 'Lake Charles Memorial', name: 'Lake Charles Memorial Hospital', address: '1701 Oak Park Blvd, Lake Charles, LA 70601', phone: '3374943000', lat: 30.2047, lon: -93.1976, er24: true, type: 'ER' },
];

// ── Distance calculation (Haversine formula) ──────────────────────
export function distanceMiles(lat1, lon1, lat2, lon2) {
  const R = 3958.8; // Earth radius in miles
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = Math.sin(dLat / 2) ** 2
          + Math.cos(lat1 * Math.PI / 180)
          * Math.cos(lat2 * Math.PI / 180)
          * Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

export function getNearestHospitals(userLat, userLon, limit = 5, erOnly = false) {
  const list = erOnly ? HOSPITALS.filter((h) => h.er24) : HOSPITALS;
  return list
    .map((h) => ({ ...h, distMiles: distanceMiles(userLat, userLon, h.lat, h.lon) }))
    .sort((a, b) => a.distMiles - b.distMiles)
    .slice(0, limit);
}